module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addBuildings":"Liegenschaften importieren","identifierTitle":"Liegenschaftsnr.","descriptionTitle":"Bezeichnung","zipCodeTitle":"Postleitzahl","municipalityTitle":"Gemeinde","uploadStateTitle":"Status","uploadFile":"JSON-Datei auswählen:"}}')
  delete Component.options._Ctor
}
